import React, { useState, useEffect } from 'react';
import { Row, Col, FormGroup, Input, Button } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { URL } from '../../api';
import axiosInstance from "../../Request";
import 'react-toastify/dist/ReactToastify.css';
import getPrivilegeList from "../../PrivilegeList";
const ReferenceDetails = ({ customerDetails, disableEdit }) => {
  const { cid,lid } = useParams();
const privilegeList = getPrivilegeList();
  const [editableDetails, setEditableDetails] = useState({
    name: "-NA-",
    phone: "-NA-",
    name2: "-NA-",
    phone2: "-NA-",
  });

  const [initialDetails, setInitialDetails] = useState({ ...editableDetails });
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => {
    if (customerDetails?.references?.length) {
      const family = customerDetails.references.find(ref => ref.type === 1);
      const friend = customerDetails.references.find(ref => ref.type === 2);

      const updated = {
        name: family?.name || "-NA-",
        phone: family?.phone || "-NA-",
        name2: friend?.name || "-NA-",
        phone2: friend?.phone || "-NA-",
      };

      setEditableDetails(updated);
      setInitialDetails(updated);
    }
  }, [customerDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableDetails(prev => ({ ...prev, [name]: value }));
  };

  const hasFamilyChanged = () =>
    editableDetails.name !== initialDetails.name ||
    editableDetails.phone !== initialDetails.phone;

  const hasFriendChanged = () =>
    editableDetails.name2 !== initialDetails.name2 ||
    editableDetails.phone2 !== initialDetails.phone2;

  const handleUpdateClick = async () => {
    const updates = [];

    if (hasFamilyChanged()) {
      const updatedFields = {};
      if (editableDetails.name !== initialDetails.name && editableDetails.name !== "-NA-") {
        updatedFields.name = editableDetails.name;
      }
      if (editableDetails.phone !== initialDetails.phone && editableDetails.phone !== "-NA-") {
        updatedFields.phone = editableDetails.phone;
      }

      if (Object.keys(updatedFields).length > 0) {
        updates.push(updateReferenceDetails(1, updatedFields));
      }
    }

    if (hasFriendChanged()) {
      const updatedFields = {};
      if (editableDetails.name2 !== initialDetails.name2 && editableDetails.name2 !== "-NA-") {
        updatedFields.name = editableDetails.name2;
      }
      if (editableDetails.phone2 !== initialDetails.phone2 && editableDetails.phone2 !== "-NA-") {
        updatedFields.phone = editableDetails.phone2;
      }

      if (Object.keys(updatedFields).length > 0) {
        updates.push(updateReferenceDetails(2, updatedFields));
      }
    }

    if (updates.length === 0) {
      toast.info("No valid changes to update.");
      setIsEditable(false);
      return;
    }

    try {
      await Promise.all(updates);
      toast.success("Reference details updated successfully");
      setInitialDetails({ ...editableDetails });
      setIsEditable(false);
    } catch (error) {
      toast.error("Failed to update reference details");
      console.error(error);
    }
  };

  const updateReferenceDetails = async (type, fields) => {
    const payload = {
      customer_id: cid,
      lead_id: lid,
      type,
      ...fields,
    };

    try {
  const response = await axiosInstance.post(URL.UPDATE_REFERENCE_DETAILS, payload);
  const result = response.data;

  if (!response.status || response.status !== 200) {
    throw new Error(result.message || "Update failed");
  }
} catch (error) {
  throw new Error(error?.response?.data?.message || "Update failed");
}
  };

  const handleEditClick = () => setIsEditable(true);

  const handleCancelClick = () => {
    setEditableDetails({ ...initialDetails });
    setIsEditable(false);
  };

  return (
    <div>
      <h6 className="heading-small text-muted mb-4">Reference</h6>
      <div className="pl-lg-4">
        <Row>
          {/* Family Reference */}
          <Col lg="6">
            <h5 className="heading-small text-muted mb-4">Family</h5>
            <FormGroup>
              <label className="form-control-label">Name</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="name"
                value={editableDetails.name}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
            <FormGroup>
              <label className="form-control-label">Phone Number</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="phone"
                value={
                  privilegeList.referenceDetailsContactInfoShow
                    ? editableDetails.phone
                    : editableDetails.phone
                      ? "******" + editableDetails.phone.slice(-4)
                      : ""
                }
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>

          {/* Friend Reference */}
          <Col lg="6">
            <h5 className="heading-small text-muted mb-4">Friend</h5>
            <FormGroup>
              <label className="form-control-label">Name</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="name2"
                value={editableDetails.name2}
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
            <FormGroup>
              <label className="form-control-label">Phone Number</label>
              <Input
                className="form-control-alternative"
                type="text"
                name="phone2"
                value={
                  privilegeList.referenceDetailsContactInfoShow
                    ? editableDetails.phone2
                    : editableDetails.phone2
                      ? "******" + editableDetails.phone2.slice(-4)
                      : ""
                }
                onChange={handleInputChange}
                disabled={!isEditable}
              />
            </FormGroup>
          </Col>

          {/* Buttons */}
          {privilegeList?.referenceDetailsEdit &&  !disableEdit && (
            <Col className="text-right" xs="12">
              {!isEditable ? (
                <Button color="primary" size="sm" onClick={handleEditClick}>
                  Edit
                </Button>
              ) : (
                <>
                  <Button color="secondary" size="sm" onClick={handleCancelClick}>
                    Cancel
                  </Button>
                  <Button color="primary" size="sm" onClick={handleUpdateClick}>
                    Update
                  </Button>
                </>
              )}
            </Col>
          )}
        </Row>
      </div>
      <hr className="my-4" />
    </div>
  );
};

export default ReferenceDetails;
